export default __webpack_public_path__ + "static/experienceImg1-a81b391c7846a2e3ba4fee1520f4ef64.png";